export default __webpack_public_path__ + "static/media/order_2.fb40e0dd.png";